import { render, staticRenderFns } from "./BookingDisplayMenu.vue?vue&type=template&id=50129352"
import script from "./BookingDisplayMenu.vue?vue&type=script&lang=js"
export * from "./BookingDisplayMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports